import React, { useRef } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { compose, space, flexbox, layout, color } from "styled-system";
import SFBLogo from "@assets/logo.svg";
import Icon from "@components/Icon";
import Div from "@components/Div";
import { Button as PRButton } from "@components/Button";
import { breakpoints } from "@utils/breakpoints";
import Steps from "@components/Steps";
import { ROUTES } from "@utils/constant";
import { resetData } from "@app/reducers/wizardDataReducer";
import { getAccounts } from "@app/services/Savings/mySavings";

const { tabletLandscape } = breakpoints;

const breakpoint = {
  mobile: `(max-width: ${tabletLandscape}px)`,
};

const Logo = styled.img`
  ${compose(space, flexbox, layout, color)};
`;

export const Button = styled(PRButton)`
  width: 36px;
  height: 36px;
  background-color: var(--white) !important;
  border: none !important;
  justify-content: center;
  align-items: center;
  &:focus {
    box-shadow: none;
  }
  @media ${breakpoint.mobile} {
    background-color: var(--primary) !important;
    border: 1px solid var(--text) !important;
  }
`;

const WizardHeader = () => {
  const menu = useRef({});
  const history = useHistory();
  const { location = {} } = history || {};
  const { pathname = "" } = location || {};
  const dispatch = useDispatch();
  const { steps = [], stepIndex = 0 } = useSelector(
    (state) => state.wizardContentReducer
  );

  const handleRedirectToHome = () => {
    dispatch(resetData());
    if (pathname !== ROUTES.WIZARD_SUCCESS.URL) {
      history.push(ROUTES.HOME.URL);
    } else {
      const fetchAccounts = async () => {
        const profile = JSON.parse(localStorage.getItem("user"));
        const [firstProfile = {}] = profile || [];
        const { BrickId = "" } = firstProfile;
        getAccounts(BrickId, true);
      };
      fetchAccounts();
      history.push(ROUTES.HOME.URL);
    }
  };

  return (
    <Div
      bg="var(--primary)"
      width={1}
      height={[90, 90, 90, 60]}
      p="var(--sm-spacing)"
    >
      <Div display="flex" alignItems="center" justifyContent="space-between">
        <Logo
          src={SFBLogo}
          alt="icon"
          onClick={(e) => menu.current.toggle(e)}
        />
        <Div display={["none", "none", "none", "flex"]}>
          {!!steps && pathname !== ROUTES.WIZARD_SUCCESS.URL && (
            <Steps content={steps} activeIndex={stepIndex} />
          )}
        </Div>
        {steps && (
          <Button onClick={handleRedirectToHome} ml="var(--sm-spacing)">
            <Icon
              className="icon ph-x-bold"
              color="var(--text)"
              fontSize="var(--fs-h5)"
            />
          </Button>
        )}
      </Div>
      <Div
        display={["flex", "flex", "flex", "none"]}
        justifyContent="center"
        mt={3}
      >
        {steps && steps.length && (
          <Steps content={steps} activeIndex={stepIndex} />
        )}
      </Div>
    </Div>
  );
};

export default WizardHeader;
